export const VALIDAR_LOADING = 'validar/VALIDAR_LOADING';
export const VALIDAR_SUCCESS = 'validar/VALIDAR_SUCCESS';
export const VALIDAR_FAILURE = 'validar/VALIDAR_FAILURE';
